import type { ConfigType } from "@/core/utils/configs.types";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:1081";
const AZURE_API_URL = process.env.REACT_APP_AZURE_API_URL || "";
const SCALEWAY_API_URL = process.env.REACT_APP_SCALEWAY_API_URL || "";
const BASE_DOMAINMAIL = process.env.REACT_APP_BASE_DOMAINMAIL || "riseup.ai";
const AZURE_BASE_DOMAINMAIL =
  process.env.REACT_APP_AZURE_BASE_DOMAINMAIL || "riseup.fr";
const SCALEWAY_BASE_DOMAINMAIL =
  process.env.REACT_APP_SCALEWAY_BASE_DOMAINMAIL || "riseup.fr";

const VALID_ENVIRONMENTS = [
  "@env@",
  "development",
  "preproduction",
  "prod",
] as const;

const ENVIRONMENT = VALID_ENVIRONMENTS.includes(
  process.env.REACT_APP_ENVIRONMENT as (typeof VALID_ENVIRONMENTS)[number],
)
  ? (process.env.REACT_APP_ENVIRONMENT as ConfigType["ENVIRONMENT"])
  : "@env@";

const CONFIGS: ConfigType = {
  API_URL,
  AZURE_API_URL,
  SCALEWAY_API_URL,
  BASE_DOMAINMAIL,
  BASE_DOMAINS: {
    [SCALEWAY_API_URL]: SCALEWAY_BASE_DOMAINMAIL,
    [AZURE_API_URL]: AZURE_BASE_DOMAINMAIL,
    [API_URL]: BASE_DOMAINMAIL,
  },
  ENVIRONMENT,
  PRIVATE_KEY: process.env.REACT_APP_PRIVATE_KEY || "",
  SHORT_NAME: process.env.REACT_APP_SHORT_NAME || "",
  ADMIN_CENTER_APP_ID: process.env.REACT_APP_ADMIN_CENTER_APP_ID || "",
  BOT_ID: process.env.REACT_APP_BOT_ID || "",
  API_DOMAINS: Array.from(
    new Set([API_URL, AZURE_API_URL, SCALEWAY_API_URL].filter(Boolean)),
  ),
  TEST_UPN: process.env.REACT_APP_TEST_UPN || "",
  TEST_TOKEN: process.env.REACT_APP_TEST_TOKEN || "",
  REVIEW_APP_BRANCH: process.env.REACT_APP_REVIEW_APP_BRANCH || "",
  MARKETING_URL:
    process.env.REACT_APP_MARKETING_URL ||
    "https://www.riseup.ai/en/request-demo",
  HELPDESK_URL:
    process.env.REACT_APP_HELPDESK_URL || "https://helpdesk.riseup.ai/hc/en-us",
  DATADOG_CLIENT_TOKEN: process.env.REACT_APP_DATADOG_CLIENT_TOKEN || "",
  DATADOG_SITE: process.env.REACT_APP_DATADOG_SITE || "datadoghq.eu",
};

export default CONFIGS;
